import { useInfiniteQuery } from '@tanstack/react-query';
import { listContents } from '../services/requests';
import type { ListContentsRequest } from '../schemas/auth';

interface UseInfiniteContentsParams extends Omit<ListContentsRequest, 'pageNumber'> {
  pageSize?: number;
}

export const useInfiniteContents = (params: UseInfiniteContentsParams) => {
  const { pageSize = 10, ...otherParams } = params;

  return useInfiniteQuery({
    queryKey: ['infiniteContents', otherParams],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await listContents({
        ...otherParams,
        pageNumber: pageParam,
        pageSize,
      });
      return response;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.result || lastPage.result.length < pageSize) {
        return undefined;
      }
      return allPages.length + 1;
    },
    staleTime: 30 * 1000, // 30 seconds - shorter than default for better real-time updates
    gcTime: 5 * 60 * 1000, // 5 minutes garbage collection time
  });
};
